module.exports = __webpack_public_path__ + "static/media/xlfile.132639fb.svg";